var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7515 1.00003L15.0012 8.50772L16.8145 4.07695L24.7515 1.00003Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21875 1.00003L11.9096 8.56926L10.1855 4.07695L2.21875 1.00003Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2439 18.3846L18.6279 22.5077L24.2165 24.1077L25.792 18.477L21.2439 18.3846Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20801 18.477L2.78351 24.1077L8.34237 22.5077L5.75617 18.3846L1.20801 18.477Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04529 11.4308L6.49951 13.8615L11.9989 14.1077L11.8206 7.95386L8.04529 11.4308Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9548 11.4308L15.1201 7.89233L15.0012 14.1077L20.5006 13.8616L18.9548 11.4308Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34253 22.5077L11.6719 20.8462L8.78843 18.5077L8.34253 22.5077Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 20.8462L18.6278 22.5077L18.1819 18.5077L15.3281 20.8462Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6278 22.5077L15.3281 20.8462L15.5957 23.0616L15.5659 24.0154L18.6278 22.5077Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34253 22.5077L11.4341 24.0154L11.4044 23.0616L11.6719 20.8462L8.34253 22.5077Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4936 17.0308L8.729 16.2001L10.6612 15.277L11.4936 17.0308Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5066 17.0308L16.3092 15.277L18.2712 16.2001L15.5066 17.0308Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34231 22.5077L8.81793 18.3846L5.7561 18.477L8.34231 22.5077Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1819 18.3846L18.6278 22.5077L21.2437 18.477L18.1819 18.3846Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5004 13.8616L15.001 14.1077L15.5063 17.0308L16.3089 15.277L18.2709 16.2L20.5004 13.8616Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72876 16.2L10.661 15.277L11.4933 17.0308L11.9987 14.1077L6.49927 13.8616L8.72876 16.2Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49951 13.8616L8.78845 18.5077L8.729 16.2L6.49951 13.8616Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2711 16.2L18.1819 18.5077L20.5006 13.8616L18.2711 16.2Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9988 14.1077L11.4934 17.0308L12.1177 20.5077L12.2663 15.9231L11.9988 14.1077Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0012 14.1077L14.7336 15.9231L14.8525 20.5077L15.5065 17.0308L15.0012 14.1077Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5065 17.0308L14.8525 20.5077L15.3282 20.8462L18.1819 18.5077L18.2711 16.2L15.5065 17.0308Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.729 16.2L8.78846 18.5077L11.6719 20.8462L12.1178 20.5077L11.4936 17.0308L8.729 16.2Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5661 24.0154L15.5958 23.0615L15.3283 22.8461H11.6422L11.4044 23.0615L11.4341 24.0154L8.34253 22.5077L9.41268 23.4308L11.6124 25H15.358L17.5578 23.4308L18.6279 22.5077L15.5661 24.0154Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3282 20.8461L14.8526 20.5077H12.1177L11.6718 20.8461L11.4043 23.0615L11.6421 22.8461H15.3282L15.5957 23.0615L15.3282 20.8461Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1676 9.00003L25.9999 4.84618L24.7514 1.00003L15.3281 8.26157L18.9548 11.4308L24.0677 12.9693L25.1973 11.6154L24.7217 11.2462L25.4946 10.5077L24.9001 10.0154L25.673 9.40003L25.1676 9.00003Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.84615L1.83234 9L1.29727 9.4L2.07015 10.0154L1.47562 10.5077L2.27824 11.2462L1.77289 11.6154L2.9025 12.9692L8.04518 11.4308L11.6718 8.26154L2.21879 1L1 4.84615Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0677 12.9692L18.9548 11.4308L20.5006 13.8616L18.1819 18.5077L21.2437 18.4769H25.7919L24.0677 12.9692Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04511 11.4308L2.90242 12.9692L1.20801 18.4769H5.75617L8.78827 18.5077L6.49933 13.8616L8.04511 11.4308Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0012 14.1077L15.3282 8.26158L16.8146 4.07697H10.1855L11.6719 8.26158L11.9989 14.1077L12.1178 15.9539V20.5077H14.8526V15.9539L15.0012 14.1077Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.297265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.20f853043733c3abc2cf4e75ca23d90b.svg";
export { ForwardRef as ReactComponent };